<template>
  <div class="height-100">
    <div class="articlemanagement height-100">
      <Row
        type="flex"
        justify="center"
        align="top"
        class="code-row-bg height-100"
      >
        <Col
          span="24"
          style="position:relative;"
          class="height-100"
        >
        <!---:is="defaultMap"--->
        <component
          is="leaflet"
          ref="mapCase"
          :areaColor="areaColorList"
          :mapContainerID="mapContainerID"
          :trackColor="'#596164'">
          <div
            class="leaflet height-100"
          >
            <div
              :id="mapContainerID"
              ref="map"
              class="map"
            ></div>
          </div>
        </component>

        <div style="position:absolute;top: 5px;right: 50%;z-index: 99">
          <Dropdown
            trigger="click"
            style="margin-left: 20px"
          >
            <Button type="primary">
              {{ langMap.view[lang] }}
              <Icon type="md-code-download" />
            </Button>
            <Dropdown-menu slot="list">
              <!--<div style="text-align: right;margin:10px;width: 700px">-->
              <Card
                :bordered="false"
                style="width: 400px"
              >
                <Table
                  highlight-row
                  :loading="tableLoading"
                  border
                  :columns="col"
                  :data="robots"
                  @on-row-click="rowClick"
                ></Table>
              </Card>
              <!--</div>-->
            </Dropdown-menu>
          </Dropdown>
        </div>
        </Col>
      </Row>
      <Spin fix v-if="pageLoading">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>{{ langMap.loading[lang] }}</div>
      </Spin>
    </div>
  </div>
</template>
<script>
import leaflet from './mapUnit/leaflet.vue';
import api from "../../../api/index.js";

import { connectWithUrl } from "@/utils/websocket.js";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
// 计算机器人重合的定时器
let robotPositionTimer = null;

let _mapCase = null;

function offsetRobotPosion(robotList) {
  // copy
  let robots = JSON.parse(JSON.stringify(robotList));
  //console.info('[初始]', robotList);
  const MIN_DIS = 0.000013;
  // 按y方向排序
  robots.sort((ra, rb) => {
    if(!ra.lastPosition || ra.lastPosition.length < 2) return 0;
    else if(!rb.lastPosition || rb.lastPosition.length < 2) return 0;
    else if (ra.lastPosition[1] > rb.lastPosition[1]) return -1;
    else return 0;
  });

  let preRobot, currentRobot;
  const len = robots.length;

  for (let i = 1, xdis, ydis; i < len; i++){
    preRobot = robots[i-1];
    currentRobot = robots[i];
    if (!preRobot.lastPosition || preRobot.lastPosition.length<2) continue;
    else if(!currentRobot.lastPosition || currentRobot.lastPosition.length<2) continue;

    xdis = Math.abs(preRobot.lastPosition[1] - currentRobot.lastPosition[1]);
    ydis = Math.abs(preRobot.lastPosition[0] - currentRobot.lastPosition[0]);
    // 两个轴方向有较大差距时才做偏移处理
    if (xdis < MIN_DIS && ydis< MIN_DIS) {
      currentRobot.lastPosition[0] = preRobot.lastPosition[0] + MIN_DIS;
      // 有变动的机器人重新绘制
      this.$refs.mapCase.drawOrUpdateRobotPosition(currentRobot);
    }
  }
  if (robotPositionTimer) window.clearTimeout(robotPositionTimer);
}

export default {
  name: "Position",
  components: {leaflet},
  data() {
    return {
      langMap:langMap,
      // 首页地图容器id
      mapContainerID: "home_map_id",
      placeSearch: null,
      height: document.documentElement.clientHeight - 160,
      map: null,
      mapLoading: true,
      areaLoading: true,
      robotLoading: true,
      robots: [
        // {
        //   id: null,
        //   name: null,
        //   status: null, //1 online 0 offline
        //   taskStatus: null,
        //   ......
        //   lastPosition: [
        //      lat,
        //      lng,
        //   ],
        //   hisPoints: [{},{}], //机器人历史轨迹数据
        //   executeTask: null,
        // }
      ],
      robotsLayer: [
        // {
        //   id: null,  //机器人id
        //   marker: null, //机器人当前位置marker图层
        //   taskPath: null, //机器人任务轨迹图层
        //   taskMarker: [], //机器人任务节点图层
        //   hisMarker: [], //机器人历史轨迹点图层
        //   hisPath: null, //机器人历史轨迹图层
        // }
      ],

      seat: [],

      taskType: "",

      robotsData: [], // 存
      timer: null, //
      tableLoading: false,
      
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
      areaColorList: state => state.app.mapAreaColor,
    }),
    pageLoading() {
      return this.mapLoading || this.areaLoading || this.robotLoading;
    },
    col() {
      return [
        {
          title: langMap.name[this.lang],
          key: "name"
        },
        {
          title: langMap.status[this.lang],
          key: "status",
          width: 85,
          render: (h, { row }) => {
            let text = langMap.offline[this.lang];
            if (row.status && row.status === 1) {
              text = langMap.online[this.lang];
            }
            return h("span", text);
          }
        },
        {
          title: langMap.task[this.lang],
          key: "taskStatus",
          render: (h, { row }) => {
            let text = "--";
            if (row.status === 1 && row.taskStatus && row.taskStatus === "1") {
              text = row.executeTask.task.name;
            }
            return h("span", text);
          }
        },
        // {
        //   title: langMap.operation[this.lang],
        //   width: 65,
        //   align: "center",
        //   render: (h, params) => {
        //     //渲染数组
        //     var renderArray = [];
        //     // renderArray.push(
        //     //   h(
        //     //     "Button",
        //     //     {
        //     //       props: {
        //     //         type: "text"
        //     //       },
        //     //       style: {
        //     //         padding: "1px",
        //     //         color: "#2d8cf0"
        //     //       },
        //     //       on: {
        //     //         click: () => {
        //     //           this.switchVideo(params.row);
        //     //         }
        //     //       }
        //     //     },
        //     //     "播放"
        //     //   )
        //     // );
        //     if (params.row.status === 1) {
        //       renderArray.push(
        //         h(
        //           "Button",
        //           {
        //             props: {
        //               type: "text"
        //             },
        //             style: {
        //               padding: "1px",
        //               color: "#2d8cf0"
        //             },
        //             on: {
        //               click: () => {
        //                 this.switchVideo(params.row);
        //               }
        //             }
        //           },
        //           langMap.play[this.lang]
        //         )
        //       );
        //     }
        //     return h("div", renderArray);
        //   }
        // }
      ]
    }
  },
  methods: {
    //初始化地图
    async initMap() {
      _mapCase = this.$refs.mapCase;
      this.mapLoading = true;
      this.areaLoading = true;
      this.robotLoading = true;
      try {
        await _mapCase.initMap();
        this.mapLoading = false;
        await this.loadAreas();
        await this.loadRobot();
      } catch (e) {
        this.mapLoading = false;
        this.areaLoading = false;
        this.robotLoading = false;
      }
    },
    //加载现有区域
    loadAreas() {
      this.areaLoading = true;
      return api.getData("task-server/fence/list", this)
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            if (res.data && res.data.length > 0) {
              _mapCase.initTargetArea(res.data);
              const area1 = JSON.parse(res.data[0].area);
              const _point = area1.length && area1[0];
              _mapCase.moveToCenter([parseFloat(_point.lon), parseFloat(_point.lat)]);
            }
          }
        })
        .finally(() => {
          this.areaLoading = false;
        });
    },
    //加载机器人
    async loadRobot() {
      this.robotLoading = true;
      this.tableLoading = true;
      try {
        const res = await api.getData("robot-server/robot/list/all", this);
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
          this.robots = [];
        } else {
          if (res.data && res.data.length > 0) {
            res.data.forEach(item => {
              item.status = item.onlineStatus ? 1 : 0;
              item.taskStatus = "0";
            });
            this.robots = res.data;
            await this.loadExecuteTask();
            this.initSocket();
          } else {
            this.robots = [];
          }
        }
      } catch (e) {
        this.robots = [];
      } finally {
        this.tableLoading = false;
        this.$nextTick(() => {
          this.robotLoading = false;
        });
      }
    },
    //加载当前任务
    loadExecuteTask() {
      return api.getData("task-server/task/execute/current", this).then(async res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          if (res.data && res.data.length > 0) {
            res.data.forEach((item1, index1, arr1) => {
              // this.taskType = item1.task.name;

              //更新机器人任务状态
              this.robots.forEach((item, index, arr) => {
                if (item1.robotId === item.id) {
                  let executeTask = item1;
                  let lastPosition = item.lastPosition;
                  if (
                    executeTask &&
                    executeTask.task &&
                    executeTask.task.nodes &&
                    executeTask.task.nodes.length > 0
                  ) {
                    if (
                      executeTask.task.nodes[0].lat &&
                      executeTask.task.nodes[0].lng
                    ) {
                      lastPosition = [
                        executeTask.task.nodes[0].lat,
                        executeTask.task.nodes[0].lng
                      ];
                    }
                  }
                  const newItem = {
                    ...item,
                    taskStatus: "1",
                    executeTask: executeTask,
                    lastPosition: lastPosition
                  };
                  this.$set(this.robots, index, newItem);

                  //加载机器人任务路径
                  this.$refs.mapCase.initTask(newItem);
                  //绘制或更新机器人位置

                  this.$refs.mapCase.drawOrUpdateRobotPosition(newItem);
                }
              });
            });
            await this.loadRobotPath();
          }
        }
      });
    },
    //加载机器人历史轨迹
    loadRobotPath() {
      let robotTaskId = [];
      this.robots.forEach((item, index, arr) => {
        if (item.id && item.executeTask && item.executeTask.id) {
          let robotIdTaskId = item.id + "_" + item.executeTask.id;
          robotTaskId.push(robotIdTaskId);
        }
      });
      return api
        .getData("notice-server/data/movement?param=" + robotTaskId.join(","))
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            if (res.data) {
              this.robots.forEach((item, index, arr) => {
                if (item.id && item.executeTask && item.executeTask.id) {
                  const robotIdTaskId = item.id + "_" + item.executeTask.id;

                  // 获取已经走过的轨迹
                  let hisPoints = res.data[robotIdTaskId].positionList;
                  // 机器人状态
                  let status = res.data[robotIdTaskId].status;
                  // 机器人最后的位置
                  let lastPosition = res.data[robotIdTaskId].location;
                  // if (hisPoints && hisPoints.length > 0) {
                  //判断如果机器人当前位置为空，则设置历史最后一个点为当前位置
                  // if (
                  //   hisPoints[hisPoints.length - 1].var1 &&
                  //   hisPoints[hisPoints.length - 1].var2
                  // ) {
                  //   lastPosition = [
                  //     hisPoints[hisPoints.length - 1].var2,
                  //     hisPoints[hisPoints.length - 1].var1
                  //   ];
                  // }
                  // }

                  const newItem = {
                    ...item,
                    status: status,
                    hisPoints: hisPoints,
                    lastPosition: lastPosition
                  };
                  this.$set(this.robots, index, newItem);
                  //绘制或更新机器人位置
                  this.$refs.mapCase.drawOrUpdateRobotPosition(newItem);
                  //绘制历史轨迹
                  this.$refs.mapCase.drawHistoryPath(newItem);
                  this.isOffsetPosition();
                }
              });
            }
          }
        });
    },
    switchVideo(row) {
      let routedata = this.$router.resolve({
        path: "/lol",
        query: {
          id: row.id,
          timestamp:''
        }
      });
      window.open(routedata.href, "_blank");
    },
    cancel(status) {
      if (!status) {
        this.pausemix();
      }
    },
    rowClick(data) {
      if (data && data.lastPosition && data.lastPosition.length === 2) {
        let point = data.lastPosition;
        this.$refs.mapCase.moveToCenter(point);
      }
    },
    genContent(robot) {
      let html =
        '<div class="input-card content-window-card"><div style="padding:2px;"><h4>' +
        robot.name +
        "</h4>" +
        '<p class="input-item">' + langMap.power[this.lang] + ':' +
        (robot.statusData && robot.statusData.stateOfCharge
          ? robot.statusData.stateOfCharge.value
          : "-") +
        "</p>" +
        '<p class="input-item">' + langMap.speedHtml[this.lang] + ':' +
        (robot.movementData ? robot.movementData.speed : "-") +
        "/" + langMap.direction[this.lang] + ":" +
        (robot.movementData ? robot.movementData.direction : "-") +
        "</p>" +
        "</div></div>";
      return html;
    },
    initSocket() {
      const userStore = this.$store.state.user.userInfo;
      const data = JSON.stringify({ type: 'online', robotId: '', data: `${userStore.userId}_data` });
      connectWithUrl('/ssdd', "workTrendSocketUrl", data, this.dataCallback);
    },
    //处理实时数据
    dataCallback(data) {
      //解析机器位置数据
      if (data) {

        let message = JSON.parse(data);
        if (message.type) {
          //console.info('this--', this);
          switch (message.type) {
            case "movement:":
              if (
                message.robotId &&
                message.data &&
                message.data.flag === 0 &&
                message.data.var1 &&
                message.data.var2
              ) {
                this.robots.forEach((item, index, arr) => {
                  if (message.robotId === item.id) {
                    if (message.data.flag === 0) {
                      //flag=0 经纬度坐标 flag=1 极坐标
                      let lastPosition = [message.data.var1, message.data.var2];
                      let hisPoints = item.hisPoints;
                      if (!hisPoints) {
                        hisPoints = [];
                      }
                      hisPoints.push(message.data);
                      const newItem = {
                        ...item,
                        lastPosition: lastPosition,
                        hisPoints: hisPoints,
                          movementData: message.data
                      };
                      this.$set(this.robots, index, newItem);
                      //绘制或更新机器人位置
                      _mapCase.drawOrUpdateRobotPosition(newItem);
                      //更新历史轨迹数据图层
                      _mapCase.drawHistoryPath(newItem);
                    }
                  }
                });
              }
              // console.log("movment data: " + data);
              break;
            case "status:":
              // console.log("status data: " + data);
              if (message.robotId && message.data) {
                this.robots.forEach((item, index, arr) => {
                  if (message.robotId === item.id) {
                    const newItem = { ...item, statusData: message.data };
                    this.$set(this.robots, index, newItem);
                    _mapCase.drawOrUpdateRobotPosition(newItem);
                  }
                });
              }
              break;
            case "notice:":
              // console.log("notice data: " + data);
              break;
            case "online:":
              if (message.robotId && message.data) {
                this.robots.forEach((item, index, arr) => {
                  if (message.robotId === item.id) {
                    const newItem = { ...item, status: 1 };
                    this.$set(this.robots, index, newItem);
                    _mapCase.drawOrUpdateRobotPosition(newItem);
                  }
                });
              }
              // console.log("online data: " + data);
              break;
            case "offline:":
              if (message.robotId && message.data) {
                this.robots.forEach((item, index, arr) => {
                  if (message.robotId === item.id) {
                    const newItem = { ...item, status: 0 };

                    this.$set(this.robots, index, newItem);
                    _mapCase.drawOrUpdateRobotPosition(newItem);
                  }
                });
              }
              console.log("offline data: " + data);
              break;
            default:
              break;
          }

          this.isOffsetPosition();
        }
      }
      //console.log(data);
    },
    // 机器人偏移判断
    isOffsetPosition() {
      if (robotPositionTimer) window.clearTimeout(robotPositionTimer);

      robotPositionTimer = setTimeout(() => {
        offsetRobotPosion.call(this, this.robots);//mockRobots
      }, 3000);
    }
  },
  mounted() {
    //初始化地图、初始化地图组件
    this.$nextTick(this.initMap);
  }
};
</script>
<style  lang="less" scoped>
/deep/.ivu-table-body{
  max-height: 500px;
  overflow: auto;
}
.articlemanagement{
  position: relative;
}
.height-100{
  height: 100%;
}
.main .content-wrapper {
  /*padding: 18px;*/
  height: 100%;
  overflow: auto;
}
.leaflet {
  width: 100%;
  height: 100%;
}
.map {
  width: 100%;
  height: calc(100%);
  z-index: 1;
}
.my-div-icon {
  background-color: transparent;
  border: 0;
}
.input-item {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  height: 3rem;
}

.input-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: 0.25rem;
  width: 22rem;
  border-width: 0;
  border-radius: 0.4rem;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 0.75rem 1.25rem;
  font-size: 12px;
}

.custom-input-card {
  width: 18rem;
}

.custom-input-card .btn:last-child {
  margin-left: 1rem;
}

.content-window-card {
  position: relative;
  width: 23rem;
  padding: 0.75rem 0 0 1.25rem;
  box-shadow: none;
  bottom: 0;
  left: 0;
}

.content-window-card p {
  height: 2rem;
}

#myPageTop {
  position: absolute;
  top: 35px;
  right: 10px;
  background: #fff none repeat scroll 0 0;
  border: 1px solid #ccc;
  margin: 10px auto;
  padding: 6px;
  font-family: "Microsoft Yahei", "微软雅黑", "Pinghei";
  font-size: 14px;
  z-index: 10;
}
#myPageTop label {
  margin: 0 20px 0 0;
  color: #666666;
  font-weight: normal;
}
#myPageTop input {
  width: 170px;
}
#myPageTop .column2 {
  padding-left: 25px;
}

.demo-spin-icon-load {
  animation: demo-spin 1s linear infinite;
}

@keyframes demo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
